export const INTEGRATIONTYPE_XERO = 'dt:integration_type:xero';
export const INTEGRATIONTYPE_NETSUITE = 'dt:integration_type:netsuite';

